module.exports = "pegasus_template/assets/header-fall-automotive-1.jpg";